import React, { lazy, Suspense } from 'react';

const LazyApiRegister = lazy(() => import('./ApiRegister'));

const ApiRegister = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyApiRegister {...props} />
  </Suspense>
);

export default ApiRegister;
